import comp from '../components/barrel';

/**
 * POST reports/client-list and download the Excel response (same as rep_advisor_client_list Download).
 * @param {string} [advisorUuid] — defaults to logged-in user_uuid
 */
export async function downloadClientListReport(advisorUuid) {
  const hdrs = await O.getAuthHdrs();
  const userUuid = hdrs.user_uuid || '';
  const advisor = advisorUuid || userUuid;

  if (!advisor) {
    comp.toast('Unable to export — user not identified.');
    return;
  }

  const method = 'reports/client-list';

  try {
    const body = {
      advisor_uuid: advisor,
      user_uuid: userUuid,
    };

    const methodObj = await O.mPOST(method, body);

    const response = await fetch(methodObj.endPoint + methodObj.method, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${hdrs.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`Export failed: ${response.statusText}`);
    }

    let contentDisposition = null;
    try {
      contentDisposition = response.headers.get('Content-Disposition');
    } catch (e) {
      /* CORS */
    }

    const slug = 'download';
    let fileName = `rep_advisor_client_list_export_${slug}`;

    if (contentDisposition) {
      const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i);
      if (quotedMatch && quotedMatch[1]) {
        fileName = quotedMatch[1].trim();
      } else {
        const unquotedMatch = contentDisposition.match(/filename\s*=\s*([^;\s]+)/i);
        if (unquotedMatch && unquotedMatch[1]) {
          fileName = unquotedMatch[1].trim();
        } else {
          const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;\s]+)/i);
          if (utf8Match && utf8Match[1]) {
            fileName = decodeURIComponent(utf8Match[1]).trim();
          }
        }
      }
    } else {
      const now = new Date();
      const dateStr = now.toISOString().slice(0, 19).replace(/:/g, '_').replace('T', '_');
      fileName = `rep_advisor_client_list_export_${slug}_${dateStr}`;
    }

    if (!fileName.toLowerCase().endsWith('.xlsx') && !fileName.toLowerCase().endsWith('.xls')) {
      fileName = fileName.replace(/\.(csv)?$/i, '') + '.xlsx';
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    comp.errorBox('Error', 'Failed to export report. Please try again.');
  }
}
